import * as React from 'react'

function RefreshIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 8557"
            transform="translate(1834 684)"
            fill="none"
            stroke="currentColor"
            strokeWidth={1}
            d="M0 0H24V24H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Start over default" transform="translate(-1834 -684)" clipPath="url(#a)">
        <g data-name="Group 55967">
          <g data-name="Group 53212">
            <g data-name="Group 52068">
              <path
                data-name="Subtraction 3"
                d="M6.172 6.171H0V0l1.72 1.72v2.623h2.623L6.17 6.169z"
                fill="currentColor"
                transform="translate(128.811 651.152) rotate(135 854.306 381.552)"
              />
            </g>
          </g>
          <path
            data-name="Path 66347"
            d="M7.713 16.829A8.825 8.825 0 01-1 7.915a9.107 9.107 0 012.332-6l1.534 1.279A7.1 7.1 0 001 7.915a6.824 6.824 0 006.713 6.915 6.824 6.824 0 006.713-6.915A6.824 6.824 0 007.713 1v-2a8.825 8.825 0 018.713 8.915 8.825 8.825 0 01-8.713 8.914z"
            transform="translate(128.811 651.152) rotate(90 843.586 880.433)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}

export default RefreshIcon
